

export function saveToLocalSession(key : string, value : any) : void {
    sessionStorage.setItem(key, value);
}


export function getFromLocalSession(key : string) : any {
    return sessionStorage.getItem(key);
}

export function removeFromLocalSession(key: string) : void  {
    sessionStorage.removeItem(key);
    
}